'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTime$002dPayload from "./presto.types$-Time-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TimePayload$() {
}
export { $c_Lpresto_types$TimePayload$ as $c_Lpresto_types$TimePayload$ };
$p = $c_Lpresto_types$TimePayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TimePayload$;
/** @constructor */
function $h_Lpresto_types$TimePayload$() {
}
export { $h_Lpresto_types$TimePayload$ as $h_Lpresto_types$TimePayload$ };
$h_Lpresto_types$TimePayload$.prototype = $p;
$p.l = (function() {
  return "TimePayload";
});
$p.cGx = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTime$002dPayload.$c_Lpresto_types$TimePayload(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$TimePayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TimePayload$, "presto.types$TimePayload$", ({
  a29: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TimePayload$ as $d_Lpresto_types$TimePayload$ };
var $n_Lpresto_types$TimePayload$;
function $m_Lpresto_types$TimePayload$() {
  if ((!$n_Lpresto_types$TimePayload$)) {
    $n_Lpresto_types$TimePayload$ = new $c_Lpresto_types$TimePayload$();
  }
  return $n_Lpresto_types$TimePayload$;
}
export { $m_Lpresto_types$TimePayload$ as $m_Lpresto_types$TimePayload$ };
//# sourceMappingURL=presto.types$-Time-Payload$.js.map
